import { render, staticRenderFns } from "./RELVeiculosAreaMapa.vue?vue&type=template&id=5126a37d&"
import script from "./RELVeiculosAreaMapa.vue?vue&type=script&lang=js&"
export * from "./RELVeiculosAreaMapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports